module.exports = __webpack_public_path__ + "img/tc4.ff785f6d.png";